import { Button, Loading } from "components/common";
import React from "react";

const IssuingProcessing = ({ timedOut, restartPolling }) => {
  return timedOut ? (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="text-3xl">Your Application is Processing</div>
      <div className="mt-4 text-lg">
        <span>Keep an eye on your inbox, or check back here later.</span>
      </div>
      <div className="mt-6">
        <Button onClick={() => restartPolling()}>
          <span>Check Again</span>
        </Button>
      </div>
    </div>
  ) : (
    <div>
      <Loading
        messages={[
          "Please wait while we check the status of your application",
          "This might take a minute",
          "Hang tight!",
        ]}
      />
    </div>
  );
};

export default IssuingProcessing;
